import moment from 'moment-timezone';
import _ from 'lodash';

export function buildEventList(localEvents, globalEvents, graphEvents) {
    const events = [];
    if (globalEvents) {
        events.push(...reduceAndSortEvents(globalEvents, graphEvents));
    }
    if (localEvents) {
        events.push(...reduceAndSortEvents(localEvents, graphEvents));
    }

    return events;
}

export function getDetails(data, graphEvents) {
    if (graphEvents.length && data.calendarEvent) {
        const linkedEvent = graphEvents.find(graphEvent => {
            return graphEvent.id === data.calendarEvent;
        });
        if (linkedEvent) {
            const adjustedTime = moment(linkedEvent.start.dateTime).tz(linkedEvent.start.timeZone)
                .tz('Canada/Eastern');
            const details = {
                location: linkedEvent.location.displayName,
                participants: linkedEvent.attendees,
                time: adjustedTime,
                title: linkedEvent.subject,
            };
            return Object.keys(details).reduce((acc, key) => {
                if (!acc[key] && details[key]) {
                    acc[key] = details[key];
                }
                return acc;
            }, data);
        }
    }
    return data;
}

export function handleClick(urlLink) {    
    if (urlLink) 
    {
        const url = urlLink.match(/^https?:/) ? urlLink : '//' + urlLink;
        window.open(url, '_blank', 'noopener,noreferrer');
    }
}

export function formatDescription(string) {
        return string;
}

function reduceAndSortEvents(events, graphEvents) {
    return Object.keys(events)
        .reduce((acc, key) => {
            const event = events[key];
            if (!event.isArchived && (event.startDate && event.endDate) && (moment(event.startDate) <= moment.now() && moment.now() <= moment(event.endDate))) {
                event.key = `event-card-${key}`;
                acc.push(event.calendarEvent && graphEvents ? getDetails(_.clone(event), graphEvents) : event);
            }
            return acc;
        }, [])
        .sort((a, b) => a.order - b.order);
}



// WEBPACK FOOTER //
// ./src/util/eventHelper.js